<script setup lang="ts">
import { computed } from 'vue'

import { useAuth } from '@/auth/useAuth'

import { formatCountdown } from './logic'
import { useMaintenance } from './useMaintenance'

const auth = useAuth()
const maintenance = useMaintenance()

const countdown = computed(() => {
  const seconds = maintenance.remainingSeconds.value
  return seconds === null ? null : formatCountdown(seconds)
})
const showScheduled = computed(() => maintenance.status.value === 'scheduled' && countdown.value !== null)
const showActiveAdmin = computed(() => maintenance.status.value === 'active' && auth.isAdmin.value)
</script>

<template>
  <Teleport to="body">
    <div v-if="showScheduled" class="maintenance-toast" role="status">
      <span class="toast-icon" aria-hidden="true">🛠️</span>
      <div class="toast-text">
        <strong>Maintenance programmée</strong>
        <span>
          L'application passe en maintenance dans <strong class="toast-countdown">{{ countdown }}</strong
          >. Merci de terminer ce que vous êtes en train de faire.
        </span>
      </div>
    </div>
    <div v-else-if="showActiveAdmin" class="maintenance-toast active-admin" role="status">
      <span class="toast-icon" aria-hidden="true">🛠️</span>
      <div class="toast-text">
        <strong>Maintenance active</strong>
        <span>Navigation admin uniquement — les utilisateurs voient la page de maintenance.</span>
      </div>
    </div>
  </Teleport>
</template>

<style scoped>
.maintenance-toast {
  position: fixed;
  right: 1rem;
  bottom: 1rem;
  z-index: 10000;
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  max-width: 380px;
  padding: 0.9rem 1.1rem;
  background: #78350f;
  color: #fef3c7;
  border: 1px solid #f59e0b;
  border-radius: 10px;
  box-shadow: 0 8px 24px rgba(17, 24, 39, 0.25);
  font-size: 0.9rem;
  line-height: 1.4;
}

.maintenance-toast.active-admin {
  background: #7f1d1d;
  color: #fee2e2;
  border-color: #ef4444;
}

.toast-icon {
  font-size: 1.25rem;
  flex-shrink: 0;
}

.toast-text {
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
}

.toast-countdown {
  font-variant-numeric: tabular-nums;
}
</style>

<style>
/* Le bandeau de maintenance d'une vue de chat remplace le bloc flottant, qui couvrirait la zone de saisie. */
body:has([data-testid='maintenance-banner']) .maintenance-toast {
  display: none;
}
</style>
